const myProjects = [
  {
    name: 'Chow',
    description: 'Phone eats first in this social media app designed around raiting meals from the resutrants you vist. No longer will you need to ask friends for their recommendations, just follow them and seeing where they Chow down!',
    screenshot: '/Chow-screen-shot2.png',
    repoLink: 'https://github.com/hpweisberg/chow-app-front-end/',
    deploymentLink: 'https://chow.yachts/',
    tools: ['React', 'JavaScript', 'HTML', 'Tailwind', 'MongoDb']
  },
  {
    name: 'MAMBA',
    description: 'A take on the classic game of Snake. Players help NBA legend Kobe Bryant, aka, “Black Mamba” secure as many NBA Championship Trophies as possible without getting a technical foul!',
    screenshot: '/mamba.jpg',
    repoLink: 'https://github.com/hpweisberg/snake',
    deploymentLink: 'https://harrison-snake.netlify.app/',
    tools: ['JavaScript', 'HTML', 'CSS']
  },
  {
    name: 'Chores for Coins',
    description: `Winner of GA's Spring Hack-a-thon. This app was designed to assist parents in teaching their children the value of money and patience. Our app rewards kids with coins for completing tasks or chores while working toward a goal or price agreed upon by their parents!`,
    screenshot: '/ChoresForCoins.png',
    repoLink: 'https://github.com/brendonvan/GA-SHT7',
    deploymentLink: `https://chores-for-coins.netlify.app/`,
    tools: ['React', 'Express.js', 'MongoDb', 'RESTful API', 'JavaScript', 'HTML', 'CSS'],
    hackathon: true,
  },
  {
    name: 'FLYy',
    description: `The flight tracker for you and your friends! Add your own flights and stay up to date by link up with your friends and family. 
    Check out your friend's journey posts or perhaps use the myJourney section to know when your family has landed safe and sound after each flight.`,
    screenshot: '/flyy.jpg',
    repoLink: 'https://github.com/hpweisberg/FLYy',
    deploymentLink: 'https://flyy-harrisonw.fly.dev/',
    tools: ['JavaScript', 'HTML', 'CSS', 'Express.js', 'MongoDb']
  },
  {
    name: 'CAST',
    description: `A better way for Casting Directors to get paired up with production talent. Instead of sifting through resumes one by one, Cast allows Talent to setup a profile and have Casting Directors reach out to them. Its more simple, streamined, and modern.`,
    screenshot: '/castUpdatedScreenShot.png',
    repoLink: 'https://github.com/hpweisberg/cast-front-end',
    deploymentLink: 'https://castapp.netlify.app/',
    tools: ['React', 'JavaScript', 'HTML', 'CSS', 'MongoDb', 'Express.js', 'RESTful API']
  },
  {
    name: 'Tic-Tac-Toe',
    description: `A remake of my first project utilizing TypeScript. Players can enter their own name to personalize the experince.`,
    screenshot: '/ttt.png',
    repoLink: 'https://github.com/hpweisberg/TTT-TS',
    deploymentLink: 'https://ttt-ts-harrison.netlify.app/',
    tools: ['TypeScript', 'HTML', 'CSS']
  },
  {
    name: 'Top Dog',
    description: `Inspired by the show Comunnity, Top Dog features the same creative spirit behind Meow Meow Beans! In this PERN stack application, users can create profiles, rate each other, update account information and delete their account.`,
    screenshot: '/topDog.png',
    repoLink: 'htthttps://github.com/hpweisberg/top-dog-front',
    deploymentLink: 'https://topdog-hw.netlify.app/',
    tools: ['TypeScript', 'React', 'PostgreSQL', 'Sequilize', 'HTML', 'CSS']
  },
]

export { myProjects }